<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-text-field
        :label="$t('entities.printer.props.code')"
        v-model="value.code"
        clearable
        :rules="$isRequiredRule"
      ></v-text-field>
      <v-text-field
        :label="$t('entities.printer.props.description')"
        v-model="value.description"
        clearable
        :rules="$isRequiredRule"
      ></v-text-field>
      <v-text-field
        :label="$t('entities.printer.props.path')"
        v-model="value.path"
        clearable
        :rules="$isRequiredRule"
      ></v-text-field>
      <v-text-field
        :label="$t('entities.printer.props.printAgentPath')"
        v-model="value.printAgentPath"
        clearable
        :rules="$isRequiredRule"
      ></v-text-field>
    </v-form>
  </v-container>
</template>
<script>
import formValidationMixin from "@/mixins/formValidationMixin";
export default {
  props: {
    value: {
      default() {
        return {
          code: "",
          description: "",
          path: "",
          printAgentPath: ""
        };
      }
    }
  },
  mixins: [formValidationMixin],
  data() {
    return {
      valid: false
    };
  },
  methods: {
  }
};
</script>